import React from 'react'
import styled from 'styled-components'

const StyledTile = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.disabled ? 0.5 : 1};
`;

const Box = styled.div`
    ${props => props.active ? `border 2px solid ${props.theme.secondary};` : `border 1px solid ${props.theme.grey};`}
    transition: all ease-in-out 0.3s;
    width: 164px;
    height: 164px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    margin-bottom: 20px;
    svg {
        color: red;
    }
`;

const Description = styled.p`
    font-size: 18px;
    font-weight: bold;
`;

const Tile = ({ icon, description, disabled, ...props }) => {
    return (
        <StyledTile {...props} disabled={disabled}>
            <Box {...props}>
                {icon}
            </Box>
            {
                description && <Description>{description}</Description>
            }
        </StyledTile>
    )
}

export default Tile
